function view (path) {
  return () => import(/* webpackChunkName: 'admin-v2' */ '@/views/admin/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAdmin = [
  {
    path: '/admin/dashboard',
    component: view('Dashboard'),
    name: 'admin.dashboard'
  },
  {
    path: '/admin/accounts/users',
    component: view('accounts/users/Base'),
    name: 'admin.accounts.users',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/accounts/customers',
    component: view('accounts/Customers'),
    name: 'admin.accounts.customers',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/accounts/customers/:customer?/managements',
    component: view('customer-management/Base'),
    name: 'admin.customers.profile',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Customers',
          to: {
            name: 'admin.accounts.customers'
          }
        },
        {
          text: 'Customer Profile',
          active: true
        }
      ]
    }
  }
]

const RAdminMaintenances = [
  {
    path: '/admin/maintenances/document-types',
    component: view('maintenances/DocumentTypes'),
    name: 'admin.maintenances.document-types',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Document Types',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/activities',
    component: view('maintenances/activities/Base'),
    name: 'admin.maintenances.activities',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Activities',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/groups',
    component: view('maintenances/ProductGroups'),
    name: 'admin.maintenances.product-groups',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Groups',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/product-categories',
    component: view('maintenances/ProductCategories'),
    name: 'admin.maintenances.product-categories',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Product Categories',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/products',
    component: view('maintenances/Products'),
    name: 'admin.maintenances.products',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Maintenances'
        },
        {
          text: 'Products',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/customers',
    component: view('maintenances/SyncCustomers'),
    name: 'admin.maintenances.sync-customers',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Customers',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/maintenances/memos',
    component: view('maintenances/Memo'),
    name: 'admin.maintenances.memos',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Memos',
          active: true
        }
      ]
    }
  }
]

const RAdminLocations = [
  {
    path: '/admin/locations/teams',
    component: view('locations/teams/Base'),
    name: 'admin.locations.teams',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Teams',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/areas',
    component: view('locations/areas/Base'),
    name: 'admin.locations.areas',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Areas',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/clusters',
    component: view('locations/clusters/Base'),
    name: 'admin.locations.clusters',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Clusters',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/regions',
    component: view('locations/Regions'),
    name: 'admin.locations.regions',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Regions',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/provinces',
    component: view('locations/Provinces'),
    name: 'admin.locations.provinces',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Provinces',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/municipalities',
    component: view('locations/Municipalities'),
    name: 'admin.locations.municipalities',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Municipalities',
          active: true
        }
      ]
    }
  },
  {
    path: '/admin/locations/barangays',
    component: view('locations/Barangays'),
    name: 'admin.locations.barangays',
    meta: {
      breadcrumb: [
        {
          text: 'Admin',
          to: {
            name: 'admin.dashboard'
          }
        },
        {
          text: 'Locations'
        },
        {
          text: 'Barangays',
          active: true
        }
      ]
    }
  }
]

export default RAdmin.concat(
  RAdminMaintenances,
  RAdminLocations
)
